<template>
  <div class="notice-field-comp flex-valign">
    <div class="flex-valign message-item-area">
      <el-checkbox label="短信通知"
                   v-model="valueInfo.sms.checked"
                   :disabled="disabled"
                   @change="changeCheck($event, 'sms')"></el-checkbox>
      <div v-if="valueInfo.sms.checked">
        <el-select class="mt10 full-width"
                   v-model="valueInfo.sms.messageModel"
                   placeholder="请选择短信模板"
                   :disabled="disabled"
                   @change="changeModel($event, 'sms')">
          <el-option v-for="(item, i) in smsMessages"
                     :key="i"
                     :label="item.noticeTemplateName"
                     :value="item.noticeTemplateCode"></el-option>
        </el-select>
        <el-input class="mt10"
                  type="textarea"
                  :rows="3"
                  placeholder="短信模板内容"
                  readonly
                  resize="none"
                  :disabled="disabled"
                  v-model="valueInfo.sms.messageContent">
        </el-input>
      </div>
    </div>
    <div class="flex-valign message-item-area mt10">
      <el-checkbox label="App消息"
                   :disabled="disabled"
                   v-model="valueInfo.appMsg.checked"
                   @change="changeCheck($event, 'appMsg')"></el-checkbox>
      <div v-if="valueInfo.appMsg.checked">
        <el-select class="mt10 full-width"
                   v-model="valueInfo.appMsg.messageModel"
                   placeholder="请选择App消息模板"
                   :disabled="disabled"
                   @change="changeModel($event, 'appMsg')">
          <el-option v-for="(item, i) in appMessages"
                     :key="i"
                     :label="item.noticeTemplateName"
                     :value="item.noticeTemplateCode"></el-option>
        </el-select>
        <el-input class="mt10"
                  type="textarea"
                  :rows="3"
                  placeholder="App消息模板内容"
                  readonly
                  resize="none"
                  :disabled="disabled"
                  v-model="valueInfo.appMsg.messageContent">
        </el-input>
      </div>
    </div>
    <div class="flex-valign message-item-area mt10">
      <el-checkbox label="微信公众号消息"
                   :disabled="disabled"
                   v-model="valueInfo.wxMsg.checked"
                   @change="changeCheck($event, 'wxMsg')"></el-checkbox>
      <div v-if="valueInfo.wxMsg.checked">
        <el-select class="mt10 full-width"
                   v-model="valueInfo.wxMsg.messageModel"
                   placeholder="请选择微信公众号消息模板"
                   :disabled="disabled"
                   @change="changeModel($event, 'wxMsg')">
          <el-option v-for="(item, i) in wxMessages"
                     :key="i"
                     :label="item.noticeTemplateName"
                     :value="item.noticeTemplateCode"></el-option>
        </el-select>
        <el-input class="mt10"
                  type="textarea"
                  :rows="3"
                  placeholder="微信公众号消息模板内容"
                  readonly
                  resize="none"
                  :disabled="disabled"
                  v-model="valueInfo.wxMsg.messageContent">
        </el-input>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "noticeField",
  model: {
    prop: "valueInfo",
    event: "handleReturn",
  },
  props: {
    disabled: {
      type: Boolean,
      default: () => {
        return false
      },
    },
    valueInfo: {
      type: Object,
      default: () => {
        return {
          sms: {},
          appMsg: {},
          wxMsg: {}
        };
      },
    },
    modelContent: {
      type: Object,
      default: () => {
        return {};
      },
    },
    smsMessages: {
      type: Array,
      default: () => {
        return [];
      },
    },
    appMessages: {
      type: Array,
      default: () => {
        return [];
      },
    },
    wxMessages: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  watch: {
    valueInfo: {
      handler (newVal) {
        this.$emit("handleReturn", this.valueInfo);
      },
      deep: true,
      immediate: true
    },
  },
  data () {
    return {};
  },
  mounted () { },
  methods: {
    changeModel (value, type) {
      this.valueInfo[type].messageContent = this.modelContent[value];
    },
    changeCheck (value, type) {
      if (!value) {
        this.valueInfo[type] = {
          checked: false
        };
      }
    },
  },
};
</script>

<style lang="scss">
</style>